import React from "react";
import {
  pathogenicColor,
  likelyPathogenicColor,
  uncertainSignificanceColor,
  benignColor,
  likelyBenignColor,
} from "../../../common/helpers/colors";
import tailwindColors from "../../../../../tailwind.colors";

const ColorLegend = () => {
  return (
    <div className="tw-my-2 tw-border tw-p-2 tw-block">
      <h5 className="tw-font-semibold tw-text-xs tw-inline-block tw-underline tw-mb-1">
        Card Colors
      </h5>
      <ul className="tw-flex tw-m-0 tw-p-0 tw-list-none">
        <li className="tw-flex tw-items-center tw-mr-3">
          <div
            className="tw-mr-1 tw-h-3 tw-w-3"
            style={{ backgroundColor: pathogenicColor }}
          />
          <div className="tw-text-2xs tw-font-semibold">Pathogenic</div>
        </li>
        <li className="tw-flex tw-items-center tw-mr-3">
          <div
            className="tw-mr-1 tw-h-3 tw-w-3"
            style={{ backgroundColor: likelyPathogenicColor }}
          />
          <div className="tw-text-2xs tw-font-semibold">Likely Pathogenic</div>
        </li>
        <li className="tw-flex tw-items-center tw-mr-3">
          <div
            className="tw-mr-1 tw-h-3 tw-w-3"
            style={{ backgroundColor: uncertainSignificanceColor }}
          />
          <div className="tw-text-2xs tw-font-semibold">
            Uncertain Significance
          </div>
        </li>
        <li className="tw-flex tw-items-center tw-mr-3">
          <div
            className="tw-mr-1 tw-h-3 tw-w-3"
            style={{ backgroundColor: likelyBenignColor }}
          />
          <div className="tw-text-2xs tw-font-semibold">Likely Benign</div>
        </li>
        <li className="tw-flex tw-items-center tw-mr-3">
          <div
            className="tw-mr-1 tw-h-3 tw-w-3"
            style={{ backgroundColor: benignColor }}
          />
          <div className="tw-text-2xs tw-font-semibold">Benign</div>
        </li>
        <li className="tw-flex tw-items-center tw-mr-3">
          <div
            className="tw-mr-1 tw-h-3 tw-w-3"
            style={{ backgroundColor: tailwindColors.blueGray[400] }}
          />
          <div className="tw-text-2xs tw-font-semibold">Generic</div>
        </li>
      </ul>
    </div>
  );
};

export default ColorLegend;
